import { Col, Modal, Row } from 'antd'
import * as React from 'react'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'
import { useMutation } from '@apollo/react-hooks'
import { OptionalFlex } from 'web-makeup/dist/styles/layout'
import Skeleton from '@yisheng90/react-loading'

import {
  ButtonWrapper,
  FormError,
  Input,
  InputLabel,
  StyledRow,
} from '../../BrandDashboardSettings/BrandDashboardSettings.style'
import { ModalContent, ModalTitle } from '../../BrandDashboardTeam/BrandTeam/brand-team.style'
import { BrandCard } from '../../components/BrandCard/BrandCard'
import DefaultButton from '../../components/DefaultButton/DefaultButton'
import SearchSection from '../../components/SearchSection/search-section'

import { client as apolloClient } from '../../../ApolloProvider/ApolloProvider'
import { Brand as BrandType, BrandDepartment, SubbrandType } from '../../../../typings/types'
import LocationForm from '../../../../components/LocationForm/LocationForm'
import { ADD_BRAND } from '../../../../mutations/AddBrand'

import {
  AntModalStyles,
  Content,
  DepartmentWrapper,
  SectionTitle,
  SubbrandsWrapper,
  Tab,
} from './SubBrands.style'
import { departmentTabs, modalCopy, subBrandsTabs } from './config'

interface SubBrandsProps {
  brandProfile?: BrandType
  brandOrderUuid?: string
  refetchBrandProfile?: () => void
  profileLoading?: boolean
}

const SubBrands: React.FC<SubBrandsProps> = ({
  brandProfile,
  brandOrderUuid,
  refetchBrandProfile,
  profileLoading,
}) => {
  const [modalVisible, setModalVisible] = React.useState(false)
  const [locationMissing, setlocationMissing] = React.useState(false)
  const [isWrongUrl, setIsWrongUrl] = React.useState(false)
  const [scrollClass, setScrollClass] = React.useState('top')

  const [currentModalView, setCurrentModalView] = React.useState('')
  const [sbData, setSbData] = React.useState({
    sbDepartment: '',
    sbName: '',
    sbWebsite: '',
    sbType: '',
  })
  const [cityUuid, setCityUuid] = React.useState('')
  const [pickedDepartment, setPickedDepartment] = React.useState<
    BrandDepartment | undefined | string
  >(undefined)
  const [searchTerm, setSearchTerm] = React.useState('')

  const [addBrand] = useMutation(ADD_BRAND, { client: apolloClient })

  React.useEffect(() => {
    document.body.className = ''
    document.body.classList.add('our-enterprise')
    return () => {
      document.body.className = ''
      document.body.classList.add('our-enterprise')
    }
  }, [])

  const isValidUrl = (url: string) => {
    const regExp = /((?:(?:http?|ftp)[s]*:\/\/)?[a-z0-9-%\/\&=?\.]+\.[a-z]{2,4}\/?([^\s<>\#%"\,\{\}\\|\\\^\[\]`]+)?)/gi
    if (regExp.test(url) || url === '') {
      return true
    }
    return false
  }

  React.useEffect(
    () => {
      if (cityUuid !== '') {
        setlocationMissing(false)
      }
    },
    [cityUuid]
  )
  React.useEffect(
    () => {
      if (sbData.sbWebsite !== '') {
        setIsWrongUrl(false)
      }
    },
    [sbData.sbWebsite]
  )

  const locationInput = <LocationForm setCityId={setCityUuid} error={locationMissing} />

  const { children: subBrandsList } = brandProfile || {}

  const subBrandSection = (type, isNull: boolean, title: string) => {
    const filteredList =
      (subBrandsList &&
        subBrandsList.filter(
          e =>
            e && isNull
              ? e.subbrandType === type || e.subbrandType === null
              : e.subbrandType === type
        )) ||
      []
    if (filteredList.length > 0) {
      return (
        <>
          <SectionTitle>{title}</SectionTitle>
          <SubbrandsWrapper>
            {!profileLoading ? (
              filteredList &&
              filteredList
                .filter(
                  item =>
                    searchTerm
                      ? item.tradingName &&
                        item.tradingName.toLowerCase().includes(searchTerm.toLowerCase())
                      : item
                )
                .map(item => (
                  <div>
                    <BrandCard brand={item} />
                  </div>
                ))
            ) : (
              <OptionalFlex>
                <Skeleton width="40%" height={32} />
                <Skeleton width="14%" height={32} />
                <Skeleton width="14%" height={32} />
              </OptionalFlex>
            )}
          </SubbrandsWrapper>
        </>
      )
    }
    return
  }

  const websiteInput = (
    <StyledRow type="flex" gutter={24}>
      <Col xs={24} sm={24} md={12} lg={12}>
        <InputLabel>Sub-brand website</InputLabel>
        <Input
          className={sbData.sbWebsite === '' ? '' : 'filled'}
          error={isWrongUrl}
          type="text"
          placeholder="Add your sub-brand’s website"
          name="website"
          onChange={e => setSbData({ ...sbData, sbWebsite: e.target.value })}
          value={sbData.sbWebsite}
        />
        {isWrongUrl && <FormError>Website name does not match criteria</FormError>}
      </Col>
    </StyledRow>
  )
  const baseView = (
    <Row type="flex" gutter={24}>
      {subBrandsTabs.map(tab => (
        <Col xs={24} sm={8}>
          <Tab
            onClick={() => {
              setCurrentModalView(tab.onClick)
              setSbData({ ...sbData, sbType: SubbrandType[tab.onClick.toUpperCase()] })
            }}
            style={{ height: '12.5rem', marginBottom: '1rem' }}
          >
            <div>
              <img src={tab.icon} alt={tab.title} />
              {tab.title}
            </div>
          </Tab>
        </Col>
      ))}
    </Row>
  )

  const locationView = (
    <>
      {websiteInput}
      {locationInput}
    </>
  )
  const handleScroll = e => {
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight
    const top = e.currentTarget.scrollTop === 0
    if (bottom) {
      setScrollClass('bottom')
    } else if (top) {
      setScrollClass('top')
    } else {
      setScrollClass('')
    }
  }
  const departmentView = (
    <>
      <DepartmentWrapper className={scrollClass} onScroll={e => handleScroll(e)}>
        <Row type="flex" gutter={16}>
          {departmentTabs.map(obj => {
            return (
              <Col
                xs={24}
                sm={8}
                md={6}
                key={obj.title}
                style={{ padding: '0.5rem' }}
                onClick={() => {
                  setPickedDepartment(obj.onClick)
                  setSbData({ ...sbData, sbDepartment: obj.onClick })
                }}
              >
                <Tab active={pickedDepartment === obj.onClick}>
                  <div>
                    <img
                      src={pickedDepartment === obj.onClick ? obj.activeIcon : obj.icon}
                      alt={obj.title}
                    />
                    {obj.title}
                  </div>
                </Tab>
              </Col>
            )
          })}
        </Row>
      </DepartmentWrapper>
      {/*  TODO >>>>>
      {pickedDepartment === 'Other' && (
        <StyledRow type="flex" gutter={24}>
          <Col xs={24} sm={24} md={12} lg={12}>
            <InputLabel>Other</InputLabel>
            <Input
              className={otherDepartment === '' ? '' : 'filled'}
              type="text"
              placeholder="Add department"
              name="other"
              onChange={e => setOtherDepartment(e.target.value)}
              value={otherDepartment}
            />
          </Col>
        </StyledRow>
      )} */}
      {locationInput}
    </>
  )

  const subBrandView = (
    <>
      <StyledRow type="flex" gutter={24}>
        <Col xs={24} sm={24} md={12} lg={12}>
          <InputLabel>Name of sub-brand</InputLabel>
          <Input
            className={sbData.sbName === '' ? '' : 'filled'}
            type="text"
            placeholder="Add your sub-brand’s name"
            name="website"
            onChange={e => setSbData({ ...sbData, sbName: e.target.value })}
            value={sbData.sbName}
          />
        </Col>
      </StyledRow>
      {websiteInput}
      {sbData.sbType === 'SUBBRAND' && locationInput}
    </>
  )
  const clerAlldata = () => {
    setSbData({
      sbName: '',
      sbWebsite: '',
      sbDepartment: '',
      sbType: '',
    })
    setCityUuid('')
  }
  const currentModalContent = () => {
    switch (currentModalView) {
      case 'location':
        return locationView
      case 'department':
        return departmentView
      case 'subBrand':
        return subBrandView
      case 'base':
        return baseView
      default:
        return baseView
    }
  }

  const buttonTrigger = () => {
    if (cityUuid === '' || !isValidUrl(sbData.sbWebsite)) {
      cityUuid === '' && setlocationMissing(true)
      !isValidUrl(sbData.sbWebsite) && setIsWrongUrl(!isValidUrl(sbData.sbWebsite))
    } else {
      addBrand({
        variables: {
          parentUuid: brandOrderUuid,
          type: sbData.sbType,
          brand: {
            tradingName: sbData.sbName,
            department: sbData.sbDepartment !== '' ? sbData.sbDepartment : null,
            website: sbData.sbWebsite,
            cityUuid,
          },
        },
      })
      setModalVisible(false)
      setCurrentModalView('')
      clerAlldata()
      setTimeout(() => {
        if (refetchBrandProfile) {
          refetchBrandProfile()
        }
      }, 500)
    }
  }
  const teamMemberModalComponent = (
    <Modal
      visible={modalVisible}
      onCancel={() => {
        setModalVisible(false)
        setCurrentModalView('')
        clerAlldata()
        setlocationMissing(false)
      }}
      width="48.5rem"
      footer={
        currentModalView !== '' && [
          <ButtonWrapper key="1">
            <DefaultButton
              fontSize="1rem"
              padding="0 1.625rem"
              backgroundColor={colors.adaptBlue}
              style={{ marginLeft: 'auto' }}
              onClick={buttonTrigger}
            >
              {modalCopy[currentModalView] && modalCopy[currentModalView].buttonText}
            </DefaultButton>
          </ButtonWrapper>,
        ]
      }
    >
      <ModalTitle>
        {currentModalView !== '' && (
          <img
            onClick={() => setCurrentModalView('')}
            src="https://res.cloudinary.com/ninety-seconds/image/upload/v1599194342/Content%20Inspiration/icon-arrow-back.svg"
            alt="Back arrow"
          />
        )}
        {modalCopy[currentModalView] ? modalCopy[currentModalView].title : 'Add new sub-brand'}
      </ModalTitle>
      <ModalContent>
        {modalCopy[currentModalView]
          ? modalCopy[currentModalView].description
          : 'Select the department type of your new sub-brand.'}
      </ModalContent>
      {currentModalView === '' ? baseView : currentModalContent()}
    </Modal>
  )

  return (
    <>
      <AntModalStyles />
      <SearchSection
        addMemberButton={() => setModalVisible(true)}
        placeholder="Find sub-brand"
        onChange={e => setSearchTerm(e.target.value)}
        buttonText="Add new sub-brand"
      />
      <Content>
        {subBrandSection('LOCATION', false, 'Location')}
        {subBrandSection('DEPARTMENT', false, 'Departments')}
        {subBrandSection('SUBBRAND', true, 'Sub-brands')}
      </Content>
      {teamMemberModalComponent}
    </>
  )
}

export default SubBrands



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/BrandDashboardSubBrands/SubBrands/SubBrands.tsx